"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMessages = void 0;

var getMessages = function getMessages(state) {
  return state.messages;
};

exports.getMessages = getMessages;